module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 105
// module chunks = 14